<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-3 black--text">
                <span class="black--text txt-head">
                  1. หลักการและเหตุผล
                </span>
                <span class="txt-normal" style="text-indent: 16px">
                (ระบุที่มาและความสำคัญของการดำเนินโครงการแสดงรายละเอียดข้อมูลของปัญหาที่ผู้ประกอบการต้องการพัฒนา
        และปรับปรุงประสิทธิภาพ และผลลัพธ์ที่คาดว่าจะได้รับจากการนําเทคโนโลยี องค์ความรู้ และความช่วยเหลือของคณะผู้เชี่ยวชาญเข้าไปแก้ไขปัญหาและพัฒนากิจการ
        เพิ่มประสิทธิภาพของกิจการของผู้ประกอบการ ชี้แจง รายละเอียดโดยย่อ)
                </span>
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextArea
                  theme="3"
                  :value="form.principle"
                  @onChange="setFormField('principle', $event)"
              ></TextArea>
            </div>

          </div>
        </div>

      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">2. วัตถุประสงค์</span>
            <span class="txt-normal" style="text-indent: 16px">
              (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ วัตถุประสงค์ของโครงการ)
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              height="100"
              :value="form.objective"
              @onChange="setFormField('objective', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              3. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              height="100"
              :value="form.industry_group"
              @onChange="setFormField('industry_group', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">4. เป้าหมาย</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              height="100"
              :value="form.target"
              @onChange="setFormField('target', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            5. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
        </div>

        <div>
          <div class="black--text mb-3">
            ศักยภาพความพร้อมของเจ้าหน้าที่และบุคลากร
          </div>
          <TextArea
              theme="3"
              :value="form.officer_potential"
              @onChange="setFormField('officer_potential', $event)"
          ></TextArea>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            องค์ความรู้เพื่อสนับสนุนผู้ประกอบการ
          </div>
          <TextArea
              theme="3"
              :value="form.knowledge"
              @onChange="setFormField('knowledge', $event)"
          ></TextArea>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            การเชื่อมโยงกับผู้เชี่ยวชาญที่ให้คำปรึกษาและหน่วยงาน/เครือข่ายภายนอก
          </div>
          <TextArea
              theme="3"
              :value="form.expert"
              @onChange="setFormField('expert', $event)"
          ></TextArea>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            รูปแบบการให้บริการพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยให้กับภาคเอกชน
          </div>
          <TextArea
              theme="3"
              :value="form.tech_service_model"
              @onChange="setFormField('tech_service_model', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            6. ขั้นตอนและขอบเขตการดำเนินโครงการ
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              :value="form.progress"
              @onChange="setFormField('progress', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            {{isFinal ? '7.' : '6.'}} ผลการดำเนินงานที่ผ่านมา
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
        </div>

        <div>
          <div class="black--text mb-3">
            ภาพรวมผลการดำเนินงานของผู้ประกอบการที่เข้าร่วมโครงการในปีงบประมาณที่ผ่านมา
          </div>
          <TextArea
              theme="3"
              :value="form.overview"
              @onChange="setFormField('overview', $event)"
          ></TextArea>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            แนวทางที่จะปรับปรุงและพัฒนาการให้บริการโดยประเมินจากการดำเนินงานที่ผ่านมา
          </div>
          <TextArea
              theme="3"
              :value="form.impr_direction"
              @onChange="setFormField('impr_direction', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            {{isFinal ? '8.' : '7.'}} แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <TextArea
              theme="3"
              :value="form.future_service"
              @onChange="setFormField('future_service', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import TextArea from "../../../components/input/TextArea"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import {eventBus} from "../../../plugins/global-funcs"
import {mapState} from "vuex"

export default {
  name: "BFormProject",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data() {
    return {
      form: {}
    }
  },
  computed: {
    ...mapState({
      ProjectForm: state => state.AForm.ProjectForm
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  created() {
    if (this.isSameId && !this.masterData.form_b) this.form = this.ProjectForm
    if (this.masterData.form_b) {
      this.form = this.masterData.form_b.form_ab_project_info
    }
    eventBus.$on('bFormProject', () => {
      eventBus.$emit('bFormProjectSend', this.form)
    })

    eventBus.$on('bFormSummary', () => {
      this.$store.commit('BForm/addSummaryData', {
        partTwoForm: this.form
      })
    })
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>